/**
 *
 * @param {HTMLElement} from
 */
HTMLElement.prototype.distanceTop = function (from) {
    let hasFromElement = typeof from !== 'undefined';
    let fromElDistanceTop = 0;
    if (hasFromElement) {
        fromElDistanceTop = window.scrollY + from.getBoundingClientRect().top;
    }
    let elDistanceTop = window.scrollY + this.getBoundingClientRect().top;

    return hasFromElement ? elDistanceTop - fromElDistanceTop : elDistanceTop;
}